import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { EditionShell } from "../components/dnh/feed/EditionShell";
import { NewsFeed } from "../components/dnh/feed/NewsFeed";

export default function StateBriefPage() {
  const { countryIso2, stateSlug } = useParams();
  const [scope, setScope] = useState(null);
  const name = scope?.state?.name || stateSlug.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase());
  return <EditionShell title={name} activeNav="Explore" testId="state-brief-page" actions={<Link className="dnh-outline-button" to={`/today?iso2=${countryIso2}&state=${encodeURIComponent(stateSlug)}&summary=1`} data-testid="state-today-summary">Today's overview</Link>}>
    <NewsFeed key={`${countryIso2}:${stateSlug}`} iso2={countryIso2} stateSlug={stateSlug} title={name} onScope={setScope} />
  </EditionShell>;
}
